import React from 'react';
import { useInternationalBuyBox } from './shared-state.js';

const withHideOnIBB = ComponentToHide => props => {
   const [internationalBuyBox] = useInternationalBuyBox();

   return internationalBuyBox ? null : <ComponentToHide {...props} />;
};

export default withHideOnIBB;
